import { Grid } from "@mui/material";
import * as React from "react";
import {
  Create,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
  TextInput,
  required,
} from "react-admin";
import { SimpleForm } from "src/enterprise/ra-rbac";
import { SubscriberStatusEnum } from "src/common/enum";
import { SampleSubscriberCreateComponent } from ".";

const MyForm = (props) => {
  return (
    <>
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} md={6}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput
              validate={required()}
              source="status"
              choices={SubscriberStatusEnum}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <TextInput
              source="email"
              label="Email"
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <ReferenceInput
              source="user"
              reference="admin/users"
            >
              <AutocompleteInput
                optionText={(record) => record.first_name+" "+record.last_name+" ("+record.email+")"}
                size="small"
                label="User"
              />
            </ReferenceInput>
          </Grid>
          <Grid item sm={12} md={6}>
            <ReferenceInput
              source="product"
              reference="admin/products"
            >
              <AutocompleteInput
                optionText={(record) => record.name+" "+record.sku}
                size="small"
                label="Product"
              />
            </ReferenceInput>
          </Grid>
          <Grid item sm={12} md={6}>
            <TextInput
              source="note"
              label="note"
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </>
  );
};

export const SampleSubscriberCreate = () => (
  <Create component={SampleSubscriberCreateComponent}>
    <MyForm />
  </Create>
);
